// extracted by mini-css-extract-plugin
export var errorIcon = "_km-1";
export var nameLogo = "_km-0";